import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Btn, inputCls } from "@/components/common";
import { CURRENCIES } from "@/lib/expenseConstants";
import { Trash2 } from "lucide-react";

const monday = () => {
  const d = new Date();
  d.setDate(d.getDate() - ((d.getDay() + 6) % 7));
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};
const fmt = (d) => d.split("-").reverse().join("/");
const money = (v, c) => `${Number(v).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${c}`;

export default function StaffTips({ staff, year }) {
  const [rows, setRows] = useState([]);
  const [f, setF] = useState({ week_start: monday(), total: "", currency: "USD", staff_ids: [] });
  const load = () => api.get(`/staff-tips?year=${year}`).then((r) => setRows(r.data));
  useEffect(() => { load(); }, [year]); // eslint-disable-line react-hooks/exhaustive-deps
  const active = staff.filter((m) => !m.deactivated_at);
  const toggle = (id) => setF((x) => ({ ...x, staff_ids: x.staff_ids.includes(id) ? x.staff_ids.filter((i) => i !== id) : [...x.staff_ids, id] }));
  const save = async () => {
    try { await api.post("/staff-tips", { ...f, total: Number(f.total) }); toast.success("Tips salvate"); setF({ ...f, total: "", staff_ids: [] }); load(); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  const del = async (t) => {
    if (!window.confirm("Eliminare questa settimana?")) return;
    try { await api.delete(`/staff-tips/${t.id}`); load(); } catch (e) { toast.error(formatApiError(e)); }
  };
  const totals = {};
  rows.forEach((t) => t.people.forEach((p) => { const k = `${p.id}|${t.currency}`; totals[k] = { name: p.name, cur: t.currency, v: ((totals[k] && totals[k].v) || 0) + t.share }; }));
  const share = f.staff_ids.length && Number(f.total) ? Number(f.total) / f.staff_ids.length : 0;

  return (
    <div className="bg-white border border-slate-200 rounded-xl p-5 mt-8" data-testid="staff-tips">
      <h2 className="text-base md:text-lg font-semibold text-slate-900 mb-3">Tips settimanali {year}</h2>
      <div className="flex flex-wrap gap-3 items-end mb-3">
        <label className="flex flex-col text-xs text-slate-600">Settimana dal (lunedì)<input type="date" value={f.week_start} onChange={(e) => setF({ ...f, week_start: e.target.value })} className={inputCls} data-testid="tips-week" /></label>
        <label className="flex flex-col text-xs text-slate-600">Totale tips<input type="number" min="0" step="0.01" value={f.total} onChange={(e) => setF({ ...f, total: e.target.value })} className={`${inputCls} w-32`} data-testid="tips-total" /></label>
        <label className="flex flex-col text-xs text-slate-600">Valuta<select value={f.currency} onChange={(e) => setF({ ...f, currency: e.target.value })} className={`${inputCls} w-24`} data-testid="tips-currency">{CURRENCIES.map((c) => <option key={c}>{c}</option>)}</select></label>
      </div>
      <div className="flex flex-wrap gap-x-4 gap-y-1 mb-3">
        {active.map((m) => (
          <label key={m.id} className="flex items-center gap-1.5 text-sm text-slate-700"><input type="checkbox" checked={f.staff_ids.includes(m.id)} onChange={() => toggle(m.id)} data-testid={`tips-staff-${m.id}`} /> {m.name}</label>
        ))}
      </div>
      <div className="flex items-center gap-3 mb-5">
        <Btn onClick={save} disabled={!share} data-testid="tips-save">Salva settimana</Btn>
        {share > 0 && <span className="text-sm text-slate-600" data-testid="tips-share-preview">{money(share, f.currency)} a testa</span>}
      </div>
      {rows.length > 0 && (
        <>
          <table className="w-full text-sm mb-4">
            <thead><tr className="text-left text-xs text-slate-500"><th className="py-1">Settimana</th><th>Totale</th><th>A testa</th><th>Ragazzi</th><th /></tr></thead>
            <tbody>
              {rows.map((t) => (
                <tr key={t.id} className="border-t border-slate-100" data-testid={`tips-row-${t.id}`}>
                  <td className="py-1.5">{fmt(t.week_start)}</td><td>{money(t.total, t.currency)}</td><td className="font-semibold">{money(t.share, t.currency)}</td>
                  <td className="text-slate-600">{t.people.map((p) => p.name).join(", ")}</td>
                  <td><button onClick={() => del(t)} className="text-rose-500" data-testid={`tips-del-${t.id}`}><Trash2 size={14} /></button></td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="text-xs font-semibold text-slate-500 mb-1">Totale per ragazzo nel {year}</div>
          <div className="flex flex-wrap gap-2" data-testid="tips-totals">
            {Object.entries(totals).map(([k, t]) => <span key={k} className="px-2.5 py-1 rounded-full bg-sky-50 text-sky-800 text-sm">{t.name}: {money(t.v, t.cur)}</span>)}
          </div>
        </>
      )}
    </div>
  );
}
